import { cx } from 'cva';
import { type FunctionComponent } from 'react';
import { Link } from '../../atoms/Link/Link';
import { useTranslation } from '../../i18n/resources';
import styles from './PrivacyDisclaimer.module.css';

export type PrivacyDisclaimerProps = {
  className?: string;
};

export const PrivacyDisclaimer: FunctionComponent<PrivacyDisclaimerProps> = ({
  className,
}) => {
  const { renderTrans } = useTranslation();

  return (
    <div className={cx(styles.root, className)}>
      {renderTrans('login', 'privacy_disclaimer_text', {
        components: {
          privacyLink: (
            <Link href="http://www.medishare.com/utility/internet-privacy" />
          ),
        },
      })}
    </div>
  );
};
